import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

const rdLightTheme = {
  dark: false,
  colors: {
    background: '#F1F4F9',
    // surface: '#FFFFFF',
    primary: '#272EB8',
    // 'primary-darken-1': '#3700B3',
    // secondary: '#03DAC6',
    // 'secondary-darken-1': '#018786',
    // error: '#B00020',
    // info: '#2196F3',
    // success: '#4CAF50',
    // warning: '#FB8C00',
  },
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'rdLightTheme',
    themes: {
      rdLightTheme,
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    VSelect: {
      variant: 'outlined',
      rounded: 'lg',
      singleLine: true,
      hideDetails: 'auto'
    },
    VTextField: {
      variant: 'outlined',
      rounded: 'lg',
      singleLine: true,
      hideDetails: 'auto',
      color: '#D8D8D8',
      bgColor: '#F1F4F9',
      autocomplete: 'off'
    },
    VBtn: {
      rounded: 'lg',
      flat: true,
      class: 'text-none'
    },
    VCard: { rounded: 'lg' },
    VRadio: {
      hideDetails: 'auto',
      density: 'compact'
    },
    VRadioGroup: {
      hideDetails: 'auto'
    },
    VTextarea: {
      rounded: 'lg',
      hideDetails: 'auto',
      variant: 'outlined',
      bgColor: 'grey-lighten-4'
    }
  }
})
